module.exports = __webpack_public_path__ + "static/media/storage.fd53a4f0.svg";